<template>
	<div class="bj">
		<div class="banner">
			<img src="~@/assets/image/aboutusbanner.png" />
			<div class="banner_des container">
			  <div class="banner_txt" style="color: #161616">{{detail.title}}</div>
			</div>
		</div>
		<div class="bj">

			<div class="container">

					<div class="shop_s_des" style="width: 100%; padding:80px 0 ">

						<div class="des" v-html="detail.content">

						</div>
					</div>					


			</div>
		</div>
		<div class="p_100"></div>

	</div>
</template>
<script>
	export default {
		name: 'AboutDetail',
		props: {},
		data() {
			return {
				list: [],
				goodsId: 0,
				detail: [],
				fangda: false,
			}
		},
		mounted() {

		},
		watch: {
			$route(to, from) {

					let goodsId = this.$route.params.goodsId
					if (goodsId) {
						this.goodsId = goodsId
						this.getarticleInfo()
					}

			},
		},


		methods: {
			fangdas() {
				this.fangda = !this.fangda;
			},
			getarticleInfo() {
				let where = {
					article_id: this.$route.params.goodsId
				};
				let that = this;
				this.$api.articleInfo(where).then(res => {
					if (res.status) {
						this.detail = res.data
						console.log("this.detail", this.detail);
					}
				})
			}
		},
		created() {
			this.getarticleInfo();
		},
	}
</script>
<style lang="scss" scoped>
	@import "@/assets/css/product_detail.scss";
</style>
